import { Device, getDevice } from '../../../util/platform.ts';
import { PitchMode } from './pitch_match_session.ts';

// Which Pitch Match mode a device starts in (issue #3518). Sing-along keeps the piano sounding
// while the singer sings, which is the richer exercise: the reference never fades while they hunt
// for the note. It only works where the device's echo canceller lets the microphone hear the
// singer while the speaker is playing.
//
// From the device research (docs/learn/audio-research.md, issue #3338): the Galaxy A03s canceller
// is half-duplex - it mutes the incoming signal while the guide sounds, so a sing-along session on
// that phone hears nothing - while the iPhone's is full-duplex and passes the voice through. No
// desktop browser has been measured, so desktop follows the iPhone and the start screen's toggle
// covers a laptop that turns out to behave like the A03s. The choice is stored per device (never on
// the household member) under LocalStorageKey.PitchMatchSingAlong, like the Rhythm calibration
// offset, because it is a property of the hardware and not of the singer.
export function defaultSingAlong(): boolean {
  return getDevice() !== Device.Android;
}

export function pitchModeFor(singAlong: boolean): PitchMode {
  return singAlong ? 'singAlong' : 'playThenListen';
}
